import { PulseBaseProvider } from '../../base-classes';

const _backgroundImageUri = '/resources/backgroundbylatlong/v1';
const _backgroundImageCacheKey = 'backgroundImage';

export class BackgroundImageProvider extends PulseBaseProvider {
	constructor(baseUrl, authId, secret, options, logger) {
		super(baseUrl, authId, secret, options, logger);
		this.storage.sync[_backgroundImageCacheKey] = this.bgImgSyncer.bind(this);
	}

	async bgImgSyncer(params) {
		const { id, syncParams, resolve, reject } = params;
		const queryParams = {
			...syncParams.stdParameters,
			latitude: syncParams.latitude,
			longitude: syncParams.longitude,
			setId: syncParams.setId,
			verbose: syncParams.verbose
		};
		return await super.syncData(syncParams.key, id, queryParams, _backgroundImageUri, resolve, reject, null, syncParams.pulseApi);
	}


	async getBackgroundByLatLng(latitude, longitude, setId = 'Default', stdParameters, verbose, refresh = false) {
		const syncParams = {
			latitude,
			longitude,
			setId,
			verbose: !!verbose,
			refresh
		};
		const id = JSON.stringify(syncParams);

		//Add the standard parameters after generating the ID because they shouldn't be part of the cache key
		syncParams.stdParameters = stdParameters;

		if (refresh) {
			super.removeFromStorage(_backgroundImageCacheKey, id);
		}
		return await super.loadFromStorage(_backgroundImageCacheKey, id, syncParams);
	}
}
